import { CHECK_IN_OPENS_MINUTES_BEFORE } from '../booking/attendance/attendance.js';
import { DOOR_ACCESS_WINDOW_MINUTES } from '../accessControl/constants.js';
export const CLUB_STATUS_VALUES = ['active', 'inactive'];
export const CLUB_COUNTRY_VALUES = ['US', 'CA', 'MX', 'GB', 'AU'];
export const DEFAULT_CLUB_COUNTRY = 'US';
export const DAYS_OF_WEEK = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
];
export const STANDARD_DURATIONS = [30, 60, 90, 120, 150, 180];
export const HOURS = {
    MIN_HOUR: 0,
    MAX_HOUR: 23,
    MIN_MINUTE: 0,
    MAX_MINUTE: 59,
    HOURS_IN_DAY: 24,
};
export const DEFAULT_AVAILABILITY_CONFIG = {
    allowedDurations: [30, 60, 90, 120, 150, 180],
    bookingInterval: 30,
    advanceBookingDays: 30,
    minAdvanceMinutes: 15,
    maxBookingDuration: 180,
    allowMidnightCrossing: true,
};
export const SLOT_INTERVAL_VALUES = [10, 15, 30, 60];
export const isSlotInterval = (value) => SLOT_INTERVAL_VALUES.includes(value);
export const MAX_SESSION_VALUES = [60, 120, 180, 240];
export const MIN_SESSION_VALUES = [30, 60, 90, 120];
export const USAGE_LIMIT_MODE_VALUES = ['hours', 'sessions'];
export const DEMO_SESSION_DURATION_VALUES = [30, 60];
function deepFreeze(value) {
    if (value !== null && typeof value === 'object') {
        for (const child of Object.values(value))
            deepFreeze(child);
        Object.freeze(value);
    }
    return value;
}
const DEMO_BOOKING_DEFAULTS = {
    minAdvanceMinutes: 120,
    sessionDurationMinutes: 30,
    hours: {
        monday: [{ startMinutes: 540, endMinutes: 1260 }],
        tuesday: [{ startMinutes: 540, endMinutes: 1260 }],
        wednesday: [{ startMinutes: 540, endMinutes: 1260 }],
        thursday: [{ startMinutes: 540, endMinutes: 1260 }],
        friday: [{ startMinutes: 540, endMinutes: 1260 }],
        saturday: [{ startMinutes: 600, endMinutes: 1200 }],
        sunday: [{ startMinutes: 600, endMinutes: 1200 }],
    },
};
export const DEFAULT_DEMO_BOOKING_CONFIG = deepFreeze(DEMO_BOOKING_DEFAULTS);
const SIMULATOR_COMPANION_DEFAULTS = {
    mode: 'enforce',
    checkInOpensMinutesBefore: CHECK_IN_OPENS_MINUTES_BEFORE,
    reminderOffsetsMinutes: [5, 1],
    offlineGraceMinutes: 30,
    maxReplayAgeMinutes: 24 * 60,
    pollGraceMinutes: 3,
    overrideUnlockMaxMinutes: 60,
    endOfSessionDelayMinutes: 0,
    extensions: {
        enabled: false,
        blockMinutes: 15,
        pricing: 'standard',
        customPriceCents: null,
        memberUsage: 'counts',
        allowPlanMinutes: true,
        confirmOnPc: false,
    },
    noShow: {
        enabled: false,
        windowMinutes: 10,
        feeCents: 1500,
        audience: [{ kind: 'drop_in' }, { kind: 'membership' }, { kind: 'pass' }],
        applyToLessons: true,
        releaseBay: false,
    },
};
export const DEFAULT_SIMULATOR_COMPANION_CONFIG = deepFreeze(SIMULATOR_COMPANION_DEFAULTS);
export const SIMULATOR_EXTENSION_PRICE_MAX_CENTS = 100000;
export const SIMULATOR_EXTENSION_BLOCK_MINUTES = [15, 30, 60];
export const SIMULATOR_NO_SHOW_WINDOW_MIN_MINUTES = 5;
export const SIMULATOR_NO_SHOW_WINDOW_MAX_MINUTES = 120;
export const SIMULATOR_NO_SHOW_FEE_MIN_CENTS = 100;
export const SIMULATOR_NO_SHOW_FEE_MAX_CENTS = 100000;
export const END_OF_SESSION_DELAY_MAX_MINUTES = 10;
export const CHECK_IN_OPENS_MINUTES_BEFORE_MAX = DOOR_ACCESS_WINDOW_MINUTES;
export const DEFAULT_DYNAMIC_RATE_CENTS = 5000;
export const DEFAULT_DYNAMIC_PEAK_UPLIFT_CENTS = 2500;
export const DEFAULT_DYNAMIC_WEEKDAY_PEAK = { startMinutes: 720, endMinutes: 1200 };
export const DEFAULT_DYNAMIC_WEEKEND_PEAK = { startMinutes: 600, endMinutes: 1320 };
const EMPTY_WEEK = {
    monday: [], tuesday: [], wednesday: [], thursday: [], friday: [], saturday: [], sunday: [],
};
function defaultPeakLayer(day, title, window) {
    return {
        id: `simple-peak-${day}`,
        label: `${title} peak hours`,
        kind: 'add',
        value: DEFAULT_DYNAMIC_PEAK_UPLIFT_CENTS,
        enabled: true,
        scope: { kind: 'weekly', days: { ...EMPTY_WEEK, [day]: [{ ...window }] } },
    };
}
const fullDayAtDefault = () => [
    { startMinutes: 0, endMinutes: 1440, rateCents: DEFAULT_DYNAMIC_RATE_CENTS },
];
export const DEFAULT_DYNAMIC_PRICING_CONFIG = deepFreeze({
    base: {
        monday: fullDayAtDefault(),
        tuesday: fullDayAtDefault(),
        wednesday: fullDayAtDefault(),
        thursday: fullDayAtDefault(),
        friday: fullDayAtDefault(),
        saturday: fullDayAtDefault(),
        sunday: fullDayAtDefault(),
    },
    layers: [
        defaultPeakLayer('monday', 'Monday', DEFAULT_DYNAMIC_WEEKDAY_PEAK),
        defaultPeakLayer('tuesday', 'Tuesday', DEFAULT_DYNAMIC_WEEKDAY_PEAK),
        defaultPeakLayer('wednesday', 'Wednesday', DEFAULT_DYNAMIC_WEEKDAY_PEAK),
        defaultPeakLayer('thursday', 'Thursday', DEFAULT_DYNAMIC_WEEKDAY_PEAK),
        defaultPeakLayer('friday', 'Friday', DEFAULT_DYNAMIC_WEEKDAY_PEAK),
        defaultPeakLayer('saturday', 'Saturday', DEFAULT_DYNAMIC_WEEKEND_PEAK),
        defaultPeakLayer('sunday', 'Sunday', DEFAULT_DYNAMIC_WEEKEND_PEAK),
    ],
});
export const DEFAULT_BOOKING_CONSTRAINTS = {
    slotIntervalMinutes: 30,
    maxSessionMinutes: 120,
    minSessionMinutes: null,
    advanceBookingDays: 14,
    minNoticeMinutes: 0,
    bookingGraceMinutes: 3,
};
export const MAX_ADVANCE_BOOKING_DAYS = 365;
export const MAX_MIN_NOTICE_MINUTES = 30 * 24 * 60;
export const MAX_BOOKING_GRACE_MINUTES = 60;
//# sourceMappingURL=constraints.js.map